<div style="display: flex;flex-direction: column;flex:1;">

  <div style="display: flex;align-self: center;margin-top: 20px;">
    <h1>{{'Induction' | translate | async}}</h1>
  </div>

  <div style="display: flex;flex-direction: column;
padding-left: 20px;
    padding-right: 20px;
    padding-top: 60px;
    padding-bottom: 20px;" class="abe-header nav">

    
    <mat-card>
      <div class="search-options"  style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;">


        <mat-form-field style="min-width: 20%;" class="header-form-full-width" >
          <span class=" label">{{"Date" | translate | async}} </span>
          <input matInput [matDatepicker]="picker" 
          placeholder="{{'Choose a date' | translate | async}}" 
          (change)="dateChange()"
           [(ngModel)]="date">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field style="min-width: 20%;" class="header-form-full-width" *ngIf="PerformInduction" >
          <span class="label">{{"Induction Type" | translate | async}}</span>
          <mat-select (selectionChange)="changePerformInductionType($event.value)"   placeholder="{{'Select Induction Type' | translate | async}}" [(ngModel)]="InductionType" ngDefaultControl>
            <mat-option *ngFor="let _type of PerformInduction.InductionTypes" [value]="_type.ID">
              {{_type.Title}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field style="min-width: 20%;" class="header-form-full-width" *ngIf="PerformInduction" >
          <span class="label">{{"State" | translate | async}}</span>
          <mat-select (selectionChange)="changePerformInductionState($event.value)"  
           placeholder="{{'Select State' | translate | async}}" [(ngModel)]="State" ngDefaultControl>
           <mat-option *ngFor="let _type of PerformInduction.States" [value]="_type.ID">
            {{_type.StateName}}
          </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field style="min-width: 20%;" class="header-form-full-width" *ngIf="PerformInduction" >
          <span class="label">{{'Facilitator' | translate | async}}</span>
          <input disabled matInput placeholder="{{'Facilitator' | translate | async}}" [(ngModel)]="PerformInduction.LogUser">
        </mat-form-field>

</div>

      

    </mat-card>

    <mat-card>
      <div *ngIf="InductionType>0" style="margin-top:20px;display: flex;flex-direction: row;justify-content: space-between;">

        <div style="display: flex;flex-direction: column;">

          <div style="display: flex;flex-direction: row;flex:1;align-items: center;">
            <span style="font-weight: bold;">
              <h5>{{"User (Already setup) being Inducted" | translate | async}}</h5>
            </span>

            <a class="button button--primary" 
            style="margin-left: 20px;min-width: 0px;"
              (click)="AddButtonClicked()">
              <i style="margin-left: 14%;" class="material-icons button__icon">add</i>
            </a>
            
          </div>

          <div style="display: flex;flex-direction: column;flex:1" >
            <mat-list role="list" *ngFor="let personInducted of ArrPersonsInducted">
              <mat-list-item role="listitem">
                <div style="display: flex;flex-direction: row;align-items: center;flex:1">
                  <div style="display: flex;flex-direction: row;align-items: center;flex:1;min-width: 200px;">
                    <mat-select style="width: 200px;" *ngIf="PerformInduction"
                      (selectionChange)="changeInductedPerson($event.value, personInducted)" placeholder="Select Option"
                      [ngModel]="personInducted.UserAuto">

                      <mat-option *ngFor="let user of PerformInduction.Users" [value]="user.UserAuto">
                        {{user.UserName}}
                      </mat-option>
                    </mat-select>
                  </div>
                  <div style="display: flex;flex-direction: row;flex:0.5">
               
                      <i style="cursor: pointer;color: red;" (click)="ClickRemovePersonFromInduct(personInducted)" class="material-icons button__icon">remove_circle_outline</i>
               
             
                      <i style="margin-left: 15px;cursor: pointer" (click)="ClickAddPersonToInduct(personInducted)" class="material-icons button__icon">add_circle_outline</i>
            
                  </div>

                </div>
              </mat-list-item>
              <mat-divider></mat-divider>
            </mat-list>
          </div>


          <div style="display: flex;flex-direction: row;flex:1;align-items: center;">
            <span style="font-weight: bold;">
              <h5>{{"User (Not setup) being Inducted" | translate | async}}</h5>
            </span>

            
            <div style="display: flex;flex-direction: row;">
              <a class="button button--primary" 
              style="margin-left: 20px;min-width: 0px;" (click)="AddInductionAttendeeClick()">
                <i style="margin-left: 14%;" class="material-icons button__icon">add</i>
              </a>
              <a class="button button--primary" style="margin-left: 20px;min-width: 0px;" 
              (click)="AddFindInductionAttendeeClick()">
                <i style="margin-left: 14%;" class="material-icons button__icon">search</i>
              </a>
            </div>
          </div>

          <div style="display: flex;flex-direction: column;flex:1"  role="list">
            <mat-list *ngFor="let personInducted of ArrExternalPersonsInducted">
              <mat-list-item role="listitem">
                <div style="display: flex;flex-direction: row;align-items: center;">
                  <div style="display: flex;flex-direction: row;align-items: center;flex:1;min-width: 200px;">
                    <span>{{personInducted.UserName}}</span>
                  </div>
                  <div style="display: flex;flex-direction: row;flex:0.5">

                    

                      <i style="margin-left: 14%;cursor: pointer;color: red;" (click)="ClickRemovePersonFromInductEx(personInducted)" 
                      class="material-icons button__icon">remove_circle_outline</i>
                  

                  </div>

                </div>
              </mat-list-item>
              <mat-divider></mat-divider>
            </mat-list>
          </div>


        </div>







      </div>


      <div style="display: flex;flex-direction: row;justify-content: flex-end;">

        <div mat-dialog-actions style="display: flex;flex-direction: row;margin-top: 20px;">
          <a class="button" (click)="ClickReset()">
            <span class="button__text">{{'Reset' | translate | async}}</span></a>
          <a class="button button--primary" style="margin-left: 20px;" (click)="ClickStart()"><span class="button__text">{{'Start' | translate | async}}</span></a>
        </div>

      </div>
    </mat-card>

  </div>

</div>